module.exports = __webpack_public_path__ + "static/media/signup-slider3.19e0ea2b.png";